import { useMemo } from 'react';

import { useIntlContext } from '#src/contexts/intl/index.ts';
import { sortBy } from '#src/lib/arrays.ts';
import countries from '#src/lib/countries.json';

export const countryCodes = Object.fromEntries(
  Object.entries(countries).map(([code, names]) => [names.en, code])
);

export const useIntlCountries = (filterTwoChars?: boolean) => {
  const { locale } = useIntlContext();
  return useMemo(
    () =>
      sortBy(
        country => country.label,
        Object.entries(countries)
          .map(entry => ({
            value: entry[0],
            label:
              entry[1]?.[locale.slice(0, 2) as keyof (typeof entry)[1]] ||
              entry[1].en,
          }))
          .filter(({ value }) => value.length === 2 || !filterTwoChars)
      ),
    [filterTwoChars, locale]
  );
};
